import styled from 'styled-components'

export const PageHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  column-gap: 12px;

  h2 {
    margin-bottom: 0;
    margin-right: auto;
  }
`
